import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import CallType from "./types/call-type";
import { callsSliceName } from "./constants";
import { getCallToken } from "./thunks/get-call-token";

export interface CallsState {
  isOnCall: boolean;
  isMicOn: boolean;
  isCameraOn: boolean;
  type: CallType;
  room: string;
  token: string;
  agentName?: string;
  agentPhotoURL?: string;
}

const initialState: CallsState = {
  isOnCall: false,
  isMicOn: true,
  isCameraOn: true,
  type: CallType.VIDEO,
  room: 'string',
  token: 'string',
  agentName: 'Others',
  agentPhotoURL: '',
}

export const callsSlice = createSlice({
  initialState,
  name: callsSliceName,
  reducers: {
    startCall: (state) => {
      state.isOnCall = true;
    },
    endCall: (state) => {
      state.isOnCall = false;
      state.token = '';
      state.room = '';
    },
    toggleMic: (state, action: PayloadAction<boolean>) => {
      state.isMicOn = action.payload;
    },
    toggleCamera: (state, action: PayloadAction<boolean>) => {
      state.isCameraOn = action.payload;
    },
    setAgentName: (state, action: PayloadAction<string>) => {
      state.agentName = action.payload;
    },
    setAgentPhotoURL: (state, action: PayloadAction<string>) => {
      state.agentPhotoURL = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getCallToken.pending, (state, action) => {
      state.token = '';
      state.isOnCall = true;
    });
    builder.addCase(getCallToken.fulfilled, (state, action) => {
      state.token = action.payload;
      state.room = 'my-room2';
    });
    builder.addCase(getCallToken.rejected, (state, action) => {
      state.token = '';
      state.room = '';
      state.isOnCall = false;
    });
  },
});

export const {
  toggleCamera,toggleMic,startCall,endCall,setAgentName,setAgentPhotoURL
} = callsSlice.actions;
